import React from 'react'
import AdminAnalytics from '../admin/components/AdminAnalaytics'

const MAnalytics = () => {
  return (
    <div><AdminAnalytics /></div>
  )
}

export default MAnalytics